module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting",
    class: {
      disabled: _vm.disabled
    }
  }, [_c('div', {
    staticClass: "setting__label",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.sub()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.item.texts.Title)))]), _vm._v(" "), _c('div', {
    staticClass: "setting__option setting__plusmin",
    attrs: {
      "id": "set-flow-air"
    }
  }, [_c('span', {
    staticClass: "setting__plusmin"
  }, [_c('span', {
    staticClass: "sub",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.sub()
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    attrs: {
      "disabled": _vm.disabled,
      "id": "ref-set-flow",
      "type": "number",
      "min": "0",
      "max": "100",
      "step": ".1"
    },
    domProps: {
      "value": _vm._f("Rounder")(_vm.item.value)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        $event.target.blur()
      },
      "focus": function($event) {
        $event.preventDefault();
        _vm.onFocus(_vm.index, $event)
      },
      "blur": function($event) {
        $event.preventDefault();
        _vm.onBlur(_vm.index, $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "add",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.add()
      }
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
    staticClass: "setting__option setting__unit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.add()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.converterType)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4558beca","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/input.field.vue
// module id = 232
// module chunks = 0